import { Button } from "@material-ui/core";
import React, { useState } from "react";
import ConfirmationModal from "../../../../Shared/ConfimationModal";

function GatewayDeleteButton({
  index,
  classes,
  handleDeleteCharge,
  customer_code,
}) {
  const [isOpen, setIsOpen] = useState({
    open: false,
    content: "",
    // deleteHandler: '',
    // item: '',
  });
  return (
    <span>
      <Button
        variant="contained"
        size="small"
        color="secondary"
        className={classes.delUserBtn}
        data-testid={`delete_gateway_btn_${customer_code}`}
        onClick={() => {
          setIsOpen({
            open: true,
            // deleteHandler: deleteRestaurantsHandler,
            // item: item.restaurant_id,
            content: "Are you sure you want to delete this gateway?",
          });
        }}
      >
        Delete
      </Button>
      {isOpen.open && (
        <ConfirmationModal
          open={isOpen.open}
          content={isOpen.content}
          // item={isOpen.item}
          deleteHandler={() => handleDeleteCharge(index)}
          setIsopen={setIsOpen}
        />
      )}
    </span>
  );
}

export default GatewayDeleteButton;
